/* eslint react/forbid-prop-types: 0 */
import React from "react";
import { Glyphicon, Table } from "react-bootstrap";
import PropTypes from "prop-types";

const JobItemList = ({
  jobItems,
  activeJobItem,
  handleRemoveJobItem,
  handleEditJobItem
}) => {
  const data = jobItems.map((jobItem, index) => {
    const jobItemId = jobItem.uuid || jobItem.id;
    const activeJobItemId = activeJobItem.uuid || activeJobItem.id;
    const className = jobItemId === activeJobItemId ? "active-job-item" : "";
    return (
      <tr key={jobItemId} className={className}>
        <td>{jobItem.item.quantity}</td>
        <td>{jobItem.item.type}</td>
        <td>{jobItem.item.description}</td>
        <td>
          <Glyphicon
            className="edit-icon"
            glyph="pencil"
            title="Edit item"
            onClick={() => handleEditJobItem(jobItem)}
          />{" "}
          <Glyphicon
            className="remove-icon"
            glyph="trash"
            title="Remove item"
            onClick={() => handleRemoveJobItem(index)}
          />
        </td>
      </tr>
    );
  });

  return (
    <div>
      <h3 className="title">
        <Glyphicon glyph="tasks" /> Items
      </h3>
      <div className="job-items-container">
        <Table className="job-item-table" striped bordered>
          <thead>
            <tr className="job-items-table-headers">
              <th style={{ width: 100 }}>Qty</th>
              <th>Type</th>
              <th>Desc</th>
              <th style={{ width: 80 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.length ? (
              data
            ) : (
              <tr>
                <td colSpan="4">
                  <p style={{ textAlign: "center" }}>No job items</p>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};
JobItemList.propTypes = {
  jobItems: PropTypes.array.isRequired,
  activeJobItem: PropTypes.object.isRequired,
  handleRemoveJobItem: PropTypes.func.isRequired,
  handleEditJobItem: PropTypes.func.isRequired
};

export default JobItemList;



// WEBPACK FOOTER //
// ./src/components/jobItems/JobItemList.js